import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import type {
  AcceptSpaceInvitationRequestDto,
  AcceptSpaceInvitationResponseDto,
  RequestNewSpaceInvitationResponseDto,
  SignUpBySpaceInvitationRequestDto,
  SignUpBySpaceInvitationResponseDto,
  SpaceInvitationResolutionDto,
} from '@sharedlib/dtos/dto/accounts/invitation-acceptance.dto';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InvitationAcceptanceApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.baseUrl}/api/account/invitations`;

  public resolve(token: string, localPart?: string): Observable<SpaceInvitationResolutionDto> {
    const params = localPart === undefined ? undefined : new HttpParams().set('localPart', localPart);
    return this.http.get<SpaceInvitationResolutionDto>(`${this.base}/${token}`, { params });
  }

  public requestNew(token: string): Observable<RequestNewSpaceInvitationResponseDto> {
    return this.http.post<RequestNewSpaceInvitationResponseDto>(`${this.base}/${token}/request-new`, null);
  }

  public accept(token: string, body: AcceptSpaceInvitationRequestDto): Observable<AcceptSpaceInvitationResponseDto> {
    return this.http.post<AcceptSpaceInvitationResponseDto>(`${this.base}/${token}/accept`, body);
  }

  public signup(
    token: string,
    body: SignUpBySpaceInvitationRequestDto,
  ): Observable<SignUpBySpaceInvitationResponseDto> {
    return this.http.post<SignUpBySpaceInvitationResponseDto>(`${this.base}/${token}/signup`, body, {
      withCredentials: true,
    });
  }
}
